import React from 'react'
import {ComponentExt} from '@utils/reactExt'
import * as styles from './index.scss'
import _ from 'lodash'

interface ScrollProps {
    style?: any
    loadingText?: any
    handleScroll: () => void
}

export default class ScrollC extends ComponentExt<ScrollProps> {
    private loadData

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.loadData = _.debounce(() => {
            if (this.getScrollHeight() === this.getDocumentTop() + this.getWindowHeight()) {
                // 当滚动条到底时,这里是触发内容
                // 异步请求数据,局部刷新dom
                this.props.handleScroll()
            }
        }, 500)
        document.getElementById('scroll-wrap').addEventListener('scroll', this.loadData)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.loadData, false)
    }

    // （浏览器窗口上边界内容高度）
    getDocumentTop = () => {
        return parseInt(String(document.getElementById('scroll-wrap').scrollTop), 10)
    }

    // 可视窗口高度（屏幕可以看见的高度）
    getWindowHeight = () => {
        return document.getElementById('scroll-wrap').clientHeight;
    }

    // 滚动条滚动高度（即整个网页的高度）
    getScrollHeight = () => {
        return document.getElementById('scroll-wrap').scrollHeight;
    }

    render() {
        return (
            <div id="scroll-wrap" className={styles.scrollWrap} style={this.props.style || {}}>
                {this.props.children}
                <div className={styles.loadingWrapper}>{this.props.loadingText}</div>
            </div>
        )
    }
}
